export default __webpack_public_path__ + "static/media/avatar.011c1641.png";